
import Vue from "vue";
import { mapState } from 'vuex';
import { changeLocale, normalizeLocale } from "@/utils/Locale"
import { env } from "@/env";
import store from '@/store';

export default Vue.extend({
  name: 'AppComponent',
  computed: {
    ...mapState(['loader']),
  },
  methods: {
    checkLanguage() {
      const userLocale = (store.state as any).userIdentity?.userIdentity?.idioma || (store.state as any).userIdentity?.userIdentity?.Idioma;
      const savedLocale = userLocale || localStorage.getItem('locale') || env.i18nLocale || 'es';
      changeLocale(normalizeLocale(savedLocale));
    },
  },
  mounted() {
    this.checkLanguage();
  },
});
